import { render, staticRenderFns } from "./entityDialog.vue?vue&type=template&id=79496c18&"
import script from "./entityDialog.vue?vue&type=script&lang=js&"
export * from "./entityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports